/**
 * @module M/impl/control/ThreeMapeaControl
 */

 import * as THREE from 'three';
 import { AnaglyphEffect } from 'impl/AnaglyphEffect.js';
 import { OrbitControls } from 'impl/OrbitControls.js';
 import { getValue } from '../../../../src/facade/js/i18n/language';
 
 
 export default class ThreeMapeaControl extends M.impl.Control {
 /**
    * @classdesc
    * Main constructor of the class. Creates a ThreeMapeaControl
    * control
    *
    * @constructor
    * @extends {M.impl.Control}
    * @api stable
    */
   constructor(capas) {
     super();
     this.capas = capas;
   }
 
 
   /**
    * This function adds the control to the specified map
    *
    * @public
    * @function
    * @param {M.Map} map to add the plugin
    * @param {HTMLElement} html of the plugin
    * @api stable
    */
   addTo(map, html) {
   // obtengo la interacción por defecto del dblclick para manejarla
   this.actualLayers = map.getLayers().filter(x => x.isVisible());
     this.zone = null;
     this.bboxImgMeters = null;
     this.newMeshMap = null;
   this.widthImg = null;
   this.eventEnabled = false;
 
     // super addTo - don't delete
     super.addTo(map, html);
   }
 
   // Add your own functions
   activateClick(map) {
     // desactivo el zoom al dobleclick
   this.map = map;
   this.selectedLayer = document.getElementById('layers-three').value;
   this.optionsSet = {sigridDTM: true, cursor3d: false, anaglyph: true};
   this.valuesSet = {comparationPlane: 0, magnification: document.getElementById('3drange').value};
   this.anaglyphType = document.getElementById('anaglyphType').value;
   this.reducMeshPcnt = 90;
   this.fov = 30;
   this.newMeshMap = 1;
   this.imagesLoading = 0;
   this.imagesLoaded = 0;
   this.idAnimation = -1;
   this.firedShift = false; //only once shift
   this.activated = true;
   this.defaultTransformation(map);
   }
 
   deactivateClick(map) {
    this.map.getImpl().getMapImpl().getLayers().getArray().filter((x) => {return x.getType() === 'TILE';}).forEach((x) => x.setOpacity(1));
    this.map.getMapImpl().removeLayer(this.map.getMapImpl().getLayers().getArray().filter((x) => x.values_.name == 'threemapealayer')[0]);
      // activo el zoom al dobleclick
    this.activated = false;
    // elimino el listener del evento
    this.showImgMap();
   }

   checkIfTheLayerIsDeleted(){
    let res = false;
    if(this.selectedLayerTransforming){
      const layers = this.map.getImpl().getMapImpl().getLayers().getArray().filter((x) => {return x.getType() === 'TILE';}).filter((layer) =>
        {return layer.getSource().layer_ === undefined
          ? (layer.getSource().getParams().fotograma !== undefined ? ('Fotograma: ' + layer.getSource().getParams().fotograma) === this.selectedLayer
          :  layer.getSource().getParams().LAYERS === this.selectedLayer)
          : layer.getSource().getLayer() === this.selectedLayer});
      if (layers.length < 1) {
          this.resetState();
          res = true;
      }
    }
    return res;
   }

   resetState(){
    this.map.getImpl().getMapImpl().getLayers().getArray().filter((x) => {return x.getType() === 'TILE';}).forEach((x) => x.setOpacity(1));
    this.map.getMapImpl().removeLayer(this.map.getMapImpl().getLayers().getArray().filter((x) => x.values_.name == 'threemapealayer')[0]);
    this.activated = false;
    const canvasMap = document.getElementById('canvasDest');
    if (canvasMap){
     canvasMap.remove();
    }
   }
 
   showImgMap(){
   const canvasMap = document.getElementById('canvasDest');
   if (canvasMap){
     this.map.getImpl().getMapImpl().getLayers().getArray().filter((x) => {return x.getType() === 'TILE';}).forEach((x) => x.setOpacity(1));
     const layer = this.map.getImpl().getMapImpl().getLayers().getArray().filter((x) => {return x.getType() === 'TILE';}).filter((layer) =>
     {return layer.getSource().layer_ === undefined
       ? (layer.getSource().getParams().fotograma !== undefined ? ('Fotograma: ' + layer.getSource().getParams().fotograma) === this.selectedLayer
       :  layer.getSource().getParams().LAYERS === this.selectedLayer)
       : layer.getSource().getLayer() === this.selectedLayer})[0];
     layer.setOpacity(1);
     this.map.getMapImpl().removeLayer(this.map.getMapImpl().getLayers().getArray().filter((x) => x.values_.name == 'threemapealayer')[0]);
     canvasMap.remove();
     }
   }
   mapUpdated() {
      M.dialog.info(getValue('loading') + '<br/><br/><div class="loader-threemapea"></div>');
      document.getElementsByClassName('m-dialog')[0].getElementsByClassName('m-button')[0].remove();
      this.updateMapWhenTilesAreLoaded();
   }
   updateMapWhenTilesAreLoaded() {
     this.counterLoading = 0;
     this.counterLoaded = 0;
     const layer = this.map.getImpl().getMapImpl().getLayers().getArray().filter((x) => {return x.getType() === 'TILE';}).filter((layer) =>
       {return layer.getSource().layer_ === undefined
         ? (layer.getSource().getParams().fotograma !== undefined ? ('Fotograma: ' + layer.getSource().getParams().fotograma) === this.selectedLayer
         :  layer.getSource().getParams().LAYERS === this.selectedLayer)
         : layer.getSource().getLayer() === this.selectedLayer})[0];
     layer.getSource().on('tileloadstart', () => {this.addCounterLoading();})
     layer.getSource().on('tileloadend', () => {this.addCounterLoaded();})
     layer.getSource().on('tileloaderror', () => {this.addCounterLoaded();})
     setTimeout(()=>this.noNewTiles(),2500);
   }
 
   addCounterLoading(){
     this.counterLoading++;
   }
 
   noNewTiles(){
   if(this.counterLoading == 0 && this.counterLoaded == 0)
     this.defaultTransformation(this.map);
   }
 
   addCounterLoaded(){
     this.counterLoaded++;
     if (this.counterLoading === this.counterLoaded && this.activated){
       this.defaultTransformation(this.map);
       const layer = this.map.getImpl().getMapImpl().getLayers().getArray().filter((x) => {return x.getType() === 'TILE';}).filter((layer) =>
         {return layer.getSource().layer_ === undefined
         ? (layer.getSource().getParams().fotograma !== undefined ? ('Fotograma: ' + layer.getSource().getParams().fotograma) === this.selectedLayer
         :  layer.getSource().getParams().LAYERS === this.selectedLayer)
         : layer.getSource().getLayer() === this.selectedLayer})[0];
       layer.getSource().un('tileloadstart', () => {this.addCounterLoading();})
       layer.getSource().un('tileloadend', () => {this.addCounterLoaded();})
       layer.getSource().un('tileloaderror', () => {this.addCounterLoaded();})
     }
   }
 
   defaultTransformation(map){
   this.imagesLoaded = 0;
   this.imagesLoading = 0;
   const layers = this.map.getImpl().getMapImpl().getLayers().getArray().filter((x) => {return x.getType() === 'TILE';}).filter((layer) =>
     {return layer.getSource().layer_ === undefined
       ? (layer.getSource().getParams().fotograma !== undefined ? ('Fotograma: ' + layer.getSource().getParams().fotograma) === this.selectedLayer
       :  layer.getSource().getParams().LAYERS === this.selectedLayer)
       : layer.getSource().getLayer() === this.selectedLayer});
   let layer = null;
   layer = layers[0];
     const bboxmap = map.getBbox();
     const zone = [bboxmap.x.min, bboxmap.y.min, bboxmap.x.max, bboxmap.y.max];
     let diccY = [];
   let diccX = [];
   let zoomModifier = !M.utils.isNullOrEmpty(layer.getSource().getTileGrid().tileSizes_) ? 4 : 0;
   layer.getSource().getTileGrid().forEachTileCoord(zone, map.getZoom() + zoomModifier, function (e) {
     if(!diccX.includes(e[1]))
       diccX.push(e[1]);
     if(!diccY.includes(e[2]))
       diccY.push(e[2]);
     });
   this.selectedLayerTransforming = new String(this.selectedLayer);
   let tileGridSize,cvsAuxH, cvsAuxW;
   if (!M.utils.isNullOrEmpty(layer.getSource().getTileGrid().tileSizes_)){
     tileGridSize = layer.getSource().getTileGrid().tileSizes_[0];
   } else {
     tileGridSize = layer.getSource().getParams().fotograma === undefined ? layer.getSource().getTileGrid().tileSize_ : layer.getSource().tmpSize[0];
   }
   cvsAuxW = diccX.length*tileGridSize;
   cvsAuxH = diccY.length*tileGridSize;
     const canvasAuxImg = document.createElement('CANVAS');
   canvasAuxImg.id = 'canvasAuxImg';
   canvasAuxImg.width = cvsAuxW;
   canvasAuxImg.height = cvsAuxH;
     canvasAuxImg.style.display = 'none';
     canvasAuxImg.setAttribute('width',cvsAuxW);
     canvasAuxImg.setAttribute('height',cvsAuxH);
   diccY = diccY.reverse();
   const ctx = canvasAuxImg.getContext('2d');
   M.dialog.info(getValue('loading') + '<br/><br/><div class="loader-threemapea"></div>');
   document.getElementsByClassName('m-dialog')[0].getElementsByClassName('m-button')[0].remove()
   // const coordsOfFirstTile = layer.getSource().getTileGrid().getTileCoordExtent([map.getZoom() + zoomModifier, diccX[0], diccY[0]]);
   // const distanceBetweenBordersTileX = coordsOfFirstTile[2] - coordsOfFirstTile[0];
   // const distanceBetweenBordersTileY = coordsOfFirstTile[3] - coordsOfFirstTile[1];
   // const distanceBetweenBboxAndTileBorderX = this.map.getBbox().x.min - coordsOfFirstTile[0];
   // const distanceBetweenBboxAndTileBorderY = this.map.getBbox().y.max - coordsOfFirstTile[1];
   // const ratioBetweenBboxAndFirstTileX = Math.round(distanceBetweenBboxAndTileBorderX/distanceBetweenBordersTileX * tileGridSize);
   // const ratioBetweenBboxAndFirstTileY = Math.round(distanceBetweenBboxAndTileBorderY/distanceBetweenBordersTileY * tileGridSize);
     for(let i=0 ; i<diccX.length ; i++){
         for(let j=0 ; j<diccY.length ; j++){
       if (layer.getSource().tileCache.entries_[(map.getZoom() + zoomModifier) + '/' + diccX[i] + '/' + diccY[j]] === undefined)
         continue;
       let imgTile = layer.getSource().tileCache.entries_[(map.getZoom() + zoomModifier) + '/' + diccX[i] + '/' + diccY[j]].value_.image_;
       if(imgTile && imgTile.naturalWidth && typeof(imgTile.naturalWidth) != 'undefined' && imgTile.naturalWidth != 0) {
         this.imagesLoading++;
         let img = new Image();
         img.crossOrigin = 'anonymous';
         img.src = imgTile.src;
         img.style.height = tileGridSize;
         img.style.width = tileGridSize;
         img.onload = function() {
           ctx.drawImage(img, 0, 0, tileGridSize, tileGridSize, tileGridSize * i, tileGridSize * j, tileGridSize, tileGridSize);
           this.imagesLoaded++;
           if(this.imagesLoading === this.imagesLoaded) {
             this.setMeshMap(canvasAuxImg, 'mapjs', zone, this.map.getProjection().code, zone);
             this.showCanvasMap(this.map);
           }
         }.bind(this);
       
         }
       }
     }
   }
 
   getBase64Image(imgOriginal, tileGridSize) {
     return new Promise((resolve, reject) => {
     const img = new Image();
     img.setAttribute('crossorigin', 'anonymous');
     img.src = imgOriginal.src;
     img.style.height = tileGridSize;
     img.style.width = tileGridSize;
     if(imgOriginal && imgOriginal.naturalWidth && typeof(imgOriginal.naturalWidth) != 'undefined' && imgOriginal.naturalWidth != 0) {
       this.imagesLoading++;
       img.onload = function can() {
         const canvas = document.createElement('canvas');
         canvas.width = img.width;
         canvas.height = img.height;
         const ctx = canvas.getContext('2d');
         ctx.drawImage(img, 0, 0);
         const dataURL = canvas.toDataURL('image/jpeg', 1.0);
         resolve(dataURL);
       };
 
       img.onerror = function rej() {
         Promise.reject(new Error(getValue('exception.loaderror')));
       };
     } else {
       resolve('No data');
     }
     });
   }
 
   showCanvasMap(map){
 
     map.getMapImpl().getLayers().getArray().filter(x => x.getVisible() && x.values_.name !== 'threemapealayer' && x.getType() !== 'VECTOR').forEach((x) => x.setOpacity(0));
 
     const canvasMap = document.getElementById('canvasDest');
     if(canvasMap){
     canvasMap.style.opacity = 0;
   }
   }
 
   setMeshMap(imgOri, desty, bboxImgOri, srsImg, zone){
 
   this.newMeshMap = 1;
   this.clearMeshMap();
   /*INI params*/
   this.imgOri = imgOri || 'http://www.idee.es/wms/PNOA/PNOA?&VERSION=1.3.0&REQUEST=GetMap&LAYERS=PNOA&FORMAT=image/jpeg&CRS=EPSG:25830&BBOX=585567.4622943781,4778782.387308146,590139.2380401064,4782399.912691853&EXCEPTIONS=application/vnd.ogc.se_inimage&WIDTH=848&HEIGHT=671';
   this.desty = desty || 'contMeshMap';
   this.bboxImgOri = [eval(bboxImgOri[0]), eval(bboxImgOri[1]), eval(bboxImgOri[2]), eval(bboxImgOri[3])] || [585567,4778782,590139,4782399];
   this.srsImg = srsImg || 'EPSG:25830';
   this.datumImg = this.getDatum(this.srsImg);
   if ( this.datumImg.proy == 'Lon-Lat' ){
       this.geo2UTM = 40000000/360;
     }else{
       this.geo2UTM = 1;
     }
     this.bboxImgMeters = [bboxImgOri[0]*this.geo2UTM,bboxImgOri[1]*this.geo2UTM,bboxImgOri[2]*this.geo2UTM,bboxImgOri[3]*this.geo2UTM];
 
     let sigridDTM, cursor3d, anaglyph;
     sigridDTM = true;
     cursor3d = false;
     anaglyph = true;
 
     /*Set params*/
     this.setMeshOptions(sigridDTM, cursor3d, anaglyph, desty);
     //this.setMeshValues();
     this.setMeshZone(zone);
 
     /*Div container*/
     this.divContainer(desty);
 
     /*Div loading*/
     this.divLoading();
 
     /*Detector Renderer*/
     if(window.CanvasRenderingContext2D){
       /*Get canvas Destiny*/
       this.cvsDesty();
       this.canvasDest = document.getElementById('canvasDest');
       // this.renderer = new THREE.CanvasRenderer({ canvas: this.canvasDest });
       // if(!this.widthImg){//sólo al inicio para que no moleste
       // 	const txtSupportWebgl = 'Su navegador parece no soportar WebGl. Por favor, actualice su versión o pruebe algún otro.';
       // 	alert(txtSupportWebgl);
 
       // 	const pSupportWebgl = document.createElement('p');
       // 	pSupportWebgl.id = 'pSupportWebgl';
       // 	pSupportWebgl.style.color = '#ff0000';
       // 	pSupportWebgl.innerHTML  = txtSupportWebgl;
       // 	document.getElementById('initDialog').appendChild(pSupportWebgl);
 
       // 	document.getElementById('anaglyphCheck').style.display = 'none';
       // 	document.getElementById('anaglyphType').style.display = 'none';
       // }
       this.renderer = new THREE.WebGLRenderer({canvas: this.canvasDest, preserveDrawingBuffer: true});
     }else{
       if (!this.widthImg) {//sólo al inicio para que no moleste
           const txtSupportHTML5 = 'Su navegador parece no soportar HTML5. Por favor, actualice su versión o pruebe algún otro.';
           alert(txtSupportHTML5);
           const pSupportHTML5 = document.createElement('p');
           pSupportHTML5.id = 'pSupportHTML5';
           pSupportHTML5.style.color = '#ff0000';
           pSupportHTML5.innerHTML  = txtSupportHTML5;
           document.getElementById('initDialog').appendChild(pSupportHTML5);
           document.getElementById('olControl3dOptionsDialog').style.display = 'none';
       }
     }
 
     this.renderer.setSize( this.canvasDestW, this.canvasDestH );
     this.renderer.setClearColor( 0xffffff );
 
     /*Anaglyph*/
     this.anaglyphRenderer = new AnaglyphEffect( this.renderer, 0 );
     this.anaglyphRenderer.setSize( this.canvasDestW,  this.canvasDestH );
 
     /*Scene*/
     this.scene = new THREE.Scene();
 
     /*Camera*/
     this.camera = new THREE.PerspectiveCamera(this.fov, this.canvasDestW / this.canvasDestH, 1, 5000000);
     //(fov ratio->zone next far ) --> makeScene update
     //this.camera = new THREE.OrthographicCamera(-window.innerWidth / 2, window.innerWidth / 2, window.innerHeight / 2, -window.innerHeight / 2, 1, 5000);
 
     /*Orbit Controls*/
     this.controls = new OrbitControls( this.camera, this.canvasDest );
     this.controls.maxPolarAngle = Math.PI/2;
     this.noOrbit( true );
     //this.controls.minPolarAngle = 0;
     //this.controls.userPanSpeed = 100;
     //this.controls.autoRotate = true;
     //this.controls.addEventListener( 'change', this.render );
 
     /*Create Image-Mesh*/
     this.makeWorld( imgOri );
 
 
     /*Events*/
     window.addEventListener( 'resize', ()=>this.onWindowResize, false );
     //canvasDest.addEventListener( 'mousemove', this.onMouseMove, false );
     //this.map.getMapImpl().getTargetElement().addEventListener('mousemove', (e) => this.onMouseMove(e)).bind(this);
     //window.addEventListener('keydown', this.startAnimation, false);
     //window.addEventListener('keyup', this.stopAnimation, false);
     document.addEventListener('keydown', this.setMeshValues, false);
     //canvasDest.addEventListener( 'mousedown', function stopAutoRotate() {this.controls.autoRotate = false;}, false );
     //document.addEventListener( 'mouseup', function startPuntCur() {shouldSphereFollowMouse=true}, false );
   }
 
   clearMeshMap() {
     const canvasDest = document.getElementById('canvasDest');
     if (canvasDest) {
       const gl = canvasDest.getContext('webgl') || canvasDest.getContext('experimental-webgl');	// Initialize the GL context
       //gl.clearColor(0.0, 0.0, 0.0, 1.0);                      // Set clear color to black, fully opaque
       gl.enable(gl.DEPTH_TEST);                               // Enable depth testing
       gl.depthFunc(gl.LEQUAL);                                // Near things obscure far things
       gl.clear(gl.COLOR_BUFFER_BIT|gl.DEPTH_BUFFER_BIT);      // Clear the color as well as the depth buffer.
     } else if (canvasDest && !!window.CanvasRenderingContext2D) {
       var ctx = canvasDest.getContext('2d');
       ctx.clearRect(0, 0, canvasDest.width, canvasDest.height);
     }
   }
 
   getDatum(srs){
     const  n = srs.length;
     let datum='';
     let huso='';
     let proy;
     if (n === 10) {
       proy = 'UTM';
       let code = srs.slice(5,8);
 
       if (code === 326) {
         datum = 'WGS84';
       } else if (code === 230) {
         datum = 'ED50';
       } else if (code === 258) {
         datum = 'ETRS89';
       }
 
       huso = srs.slice(-2);
     } else if (n === 9) {
       proy = 'Lon-Lat';
       let code = srs.slice(5,9);
       if (code === 4326){
         datum='WGS84';
       } else if(code==4230) {
         datum='ED50';
       } else if(code==4258) {
         datum='ETRS89';
       }
     }
 
     //if (datum == 'WGS84')datum='ETRS89';
 
     return { datum: datum, huso: huso, proy: proy };
   }
 
   setMeshOptions(sigridDTMopt, cursorOpt, anaglyphOpt, desty){
     /*sigridDTM*/
     const sigridDTMoptB4 = this.optionsSet.sigridDTM;
     sigridDTMopt = this.getTrueFalseDef(sigridDTMopt);
 
     if(sigridDTMopt=='def'){sigridDTMopt=false;}
 
     /*Cursor3d*/
     cursorOpt = this.getTrueFalseDef(cursorOpt);
 
     if(cursorOpt=='def'){cursorOpt=true;}
     let infoGeo3d = document.getElementById('infoGeo3d');
     const cvsDesty = document.getElementsByClassName('ol-viewport')[0];
     if(!infoGeo3d){
       infoGeo3d = document.createElement('div');
       infoGeo3d.id = 'infoGeo3d';
       infoGeo3d.style.position = 'absolute';
       infoGeo3d.style.fontSize = '10px';
       infoGeo3d.style.margin = '25px';
       infoGeo3d.style.backgroundColor = '#fff';
       infoGeo3d.style.zIndex = 1001;
       infoGeo3d.innerHTML  = '<b>Project: - Datum: </b><br><b>X/lon:</b><br><b>Y/lat:</b><br><b>Z:</b>';
       cvsDesty.appendChild(infoGeo3d);
     }
 
     if( cursorOpt == true ){
       infoGeo3d.style.display = 'block';
       //cvsDesty.style.cursor = 'none';
     }else{
       infoGeo3d.style.display = 'none';
       //cvsDesty.style.cursor = 'auto';
     }
 
     /*Anaglyph*/
     anaglyphOpt = this.getTrueFalseDef(anaglyphOpt);
 
     if(anaglyphOpt=='def'){anaglyphOpt=false;}
 
     this.optionsSet = {sigridDTM: sigridDTMopt, cursor3d: cursorOpt, anaglyph: anaglyphOpt};
 
     if(sigridDTMoptB4 != sigridDTMopt && this.newMeshMap == 0 && this.widthImg){
       this.makeZmesh();
     }else if(this.newMeshMap == 0 && this.widthImg){
       this.renderScene();//anaglyph
     }
 
   }
 
   getTrueFalseDef(boolValue){
 
   boolValue = boolValue.toString();
   if (boolValue === 'true') {
     boolValue = true;
   }else if (boolValue === 'false'){
     boolValue = false;
   }else{
     boolValue = 'def';
   }
 
   return boolValue;
 }
 
   setMeshZone(zone){
 
     var zoneB4 = [];
     zoneB4 = this.zone;
 
     if(zone && zone[3]){
       this.zone = [eval(zone[0])*this.geo2UTM, eval(zone[1])*this.geo2UTM, eval(zone[2])*this.geo2UTM, eval(zone[3])*this.geo2UTM];
     }else{
       this.zone = this.bboxImgMeters;
     }
     if(zoneB4 != this.zone && this.newMeshMap == 0 && this.widthImg){
       M.dialog.info(getValue('loading') + '<br/><br/><div class="loader-threemapea"></div>');
       document.getElementsByClassName('m-dialog')[0].getElementsByClassName('m-button')[0].remove()
       this.makeScene();
     }
   }
 
   makeScene(){
 
     let zone = this.zone;
 
     /*Params Camera*//*updateProjectionMatrix - PETA EL CURSOR*/
     if( (zone[3] - zone[1])>500000 ){
       this.fov = 70;
     }else if( (zone[3] - zone[1])<50000 ){
       this.fov = 30;
     }else{
       let terr = zone[3] - zone[1];
       this.fov = 30+((70-30)*(terr-50000)/(500000-50000));
     }
 
     this.camera.near = 1;
     this.camera.far = 10000000;
     this.camera.fov = this.fov;
     this.camera.updateProjectionMatrix();
 
     /*Position Camera*/
     //x,y,z --> x,z,-y
     let radianFOV = this.fov*2*Math.PI/360;
     let cameraPositionZ = Math.cos(radianFOV/2)*(zone[3] - zone[1])/(2*Math.sin(radianFOV/2)) + this.zMed;
     if(cameraPositionZ < this.zMax)
       cameraPositionZ = this.zMax+100;
 
     this.camera.position.z = cameraPositionZ;
     this.camera.position.y = ( zone[3] + zone[1] )/2;
     this.camera.position.x = ( zone[2] + zone[0] )/2;
 
     this.zeroParallax = this.camera.position.z - this.zMed;
     this.z0camera = this.camera.position.z
     /*Set Center Movements*/
     //(x,zOrbit,z)
     this.controls.center.set( this.camera.position.x, this.camera.position.y, this.zMed );
     this.controls.update();
 
     this.renderScene();
   }
 
   renderScene() {
 
     if(this.optionsSet.anaglyph){
       this.anaglyphRenderer.render(this.scene, this.camera);
       //this.anaglyphRenderer.render(this.scene, this.camera);
       this.setMeshValues();
     }else{
       this.renderer.render(this.scene, this.camera);
     }
   }
 
   setMeshValues(meshValuesInput){
 
     let meshValues = meshValuesInput || this.valuesSet;
     for(var k in meshValues){
       this.valuesSet[k] = meshValues[k];
     }
     if(this.widthImg)
       this.anaglyphRenderer.updateStereoParams( this.scene, this.camera, this.fov, this.z0camera, this.zeroParallax, this.valuesSet.comparationPlane, this.valuesSet.magnification );
   }
 
   divContainer(desty){
 
     let contMeshMap;
     if(typeof(desty) == 'object'){
       contMeshMap = this.imgOri;
     }else{
       contMeshMap = document.getElementsByClassName('ol-viewport')[0];
       if(!contMeshMap){
         alert('invalid destiny');
       }
     }
 
     this.canvasDestW = document.documentElement.offsetWidth;
     this.canvasDestH = document.documentElement.offsetHeight;
     this.canvasDestZindex = parseInt(contMeshMap.style.zIndex) || 100;
     contMeshMap.style.position='relative';
   }
 
   divLoading(){
     M.dialog.info(getValue('loading') + '<br/><br/><div class="loader-threemapea"></div>');
     document.getElementsByClassName('m-dialog')[0].getElementsByClassName('m-button')[0].remove()
   }
 
   cvsDesty(){
 
     let canvasDest = document.getElementById('canvasDest');
     if(!canvasDest){
       canvasDest = document.createElement('CANVAS');
       canvasDest.id = 'canvasDest';
       canvasDest.style.position = 'absolute';
       canvasDest.style.top = '0px';
       canvasDest.style.left = '0px';
       canvasDest.style.zIndex = this.canvasDestZindex;
       canvasDest.setAttribute('width', this.canvasDestW);
       canvasDest.setAttribute('height', this.canvasDestH);
 
       document.getElementsByClassName('ol-viewport')[0].appendChild(canvasDest);
     }
   }
 
   noOrbit(bool){
 
     this.controls.noPan = bool;
     this.controls.noZoom = bool;
     this.controls.noRotate = bool;
     this.controls.noKeys = bool;
   }
 
   makeWorld( imgOri ){
 
     if(typeof(imgOri) == 'object'){
       this.makeObjects(imgOri);
     }else{
       var imgOriUper = imgOri.toUpperCase();
       if(imgOriUper.indexOf('HTTP://')==-1){
         this.obtainImageFromID(imgOri);
       }else{
         this.obtainImageFromPath(imgOri);
       }
     }
   }
 
 
   makeObjects(imgConteint){
 
     this.widthImg = /*imgConteint.naturalWidth ||*/ imgConteint.width;
     this.heightImg = /*imgConteint.naturalHeight ||*/ imgConteint.height;
     imgConteint.crossOrigin = 'anonymous';
     /*Texture-Material*/
     const texture = new THREE.Texture( imgConteint );
     texture.needsUpdate = true;
     this.material = new THREE.MeshBasicMaterial( { map: texture } );
 
     /*Reduction Mesh*/
     this.reducMesh = this.getPercentage( this.reducMeshPcnt );
     this.reducMeshW = Math.round( this.widthImg*this.reducMesh );
     this.reducMeshH = Math.round( this.heightImg*this.reducMesh );
 
     /*Image-Mesh*/
     let geometry = new THREE.PlaneGeometry( this.bboxImgMeters[2] - this.bboxImgMeters[0], this.bboxImgMeters[3] - this.bboxImgMeters[1], this.reducMeshW, this.reducMeshH );
     //geometry.applyMatrix( new THREE.Matrix4().makeRotationX( - Math.PI / 2 ) );
     this.mesh = new THREE.Mesh( geometry, this.material );
     this.mesh.geometry.dynamic = true;
     this.mesh.name = 'mesh3d';
     //this.mesh.rotation.x = -Math.PI/2;
     //x,z --> x,z
     this.mesh.position.y = ( this.bboxImgMeters[3] + this.bboxImgMeters[1] )/2;
     this.mesh.position.x = ( this.bboxImgMeters[2] + this.bboxImgMeters[0] )/2;
     this.scene.add(this.mesh);
 
     /*Geometry Cursor3d*/
     const reducPointer = 50;
     geometry = new THREE.CylinderGeometry( (this.bboxImgMeters[2] - this.bboxImgMeters[0])/(4*reducPointer), 0, (this.bboxImgMeters[2] - this.bboxImgMeters[0])/reducPointer, 3 );
     geometry.applyMatrix( new THREE.Matrix4().makeTranslation( 0, (this.bboxImgMeters[2] - this.bboxImgMeters[0])/(2*reducPointer), 0 ) );
     geometry.applyMatrix( new THREE.Matrix4().makeRotationX( Math.PI / 2 ) );
     this.helper = new THREE.Mesh( geometry, new THREE.MeshNormalMaterial() );
     this.helper.visible = false;
     this.scene.add( this.helper );
 
     /*Add Z values to Mesh*/
     this.makeZmesh();
   }
 
   getPercentage(toPercentage){
     if(toPercentage >= 100){
       toPercentage = 99;
     }
 
     return 1 - toPercentage/100;
   }
 
 
   makeZmesh(){
 
     const widthDTM = this.reducMeshW + 1;
     const heightDTM = this.reducMeshH + 1;
     this.tPixImg = this.getSizePix();
     const sizePix = this.tPixImg/this.reducMesh;
 
     const bboxDTM0 = eval(this.bboxImgOri[0])-sizePix/2;
     const bboxDTM1 = eval(this.bboxImgOri[1])-sizePix/2;
     const bboxDTM2 = eval(this.bboxImgOri[2])+sizePix/2;
     const bboxDTM3 = eval(this.bboxImgOri[3])+sizePix/2;
     const srsDTM = this.srsImg;
     this.arrayZ = [];
 
     if(this.optionsSet.sigridDTM){
       this.arrZ = this.obtainZmeshRtr(widthDTM,heightDTM,bboxDTM0,bboxDTM1,bboxDTM2,bboxDTM3,srsDTM);
     }else{
       this.arrZ = this.obtainZmeshAsc(widthDTM,heightDTM,bboxDTM0,bboxDTM1,bboxDTM2,bboxDTM3,srsDTM);
     }
   }
 
   getSizePix(){
     const tPixW = (this.bboxImgOri[2]-this.bboxImgOri[0])/this.widthImg;
     const tPixH = (this.bboxImgOri[3]-this.bboxImgOri[1])/this.heightImg;
     const tPix = (tPixW+tPixH)/2;
     return tPix;
   }
 
   obtainImageFromID(image){
 
     //var imgConteint = new Image();
     const imgConteint = document.getElementById(image);
     //var context = canvas.getContext('2d');
     //imgConteint.src = canvas.toDataURL();
     this.makeObjects(imgConteint);
   }
 
   obtainImageFromPath(image){
 
     const imgConteint = new Image();
     let trying = 5;
     imgConteint.onload = function() {
 
       this.makeObjects(imgConteint);
     };
 
     imgConteint.onerror = function() {
 
       if(trying>=0){
         imgConteint.src = image;
         trying--;
       }else{
         alert('can not load image correctly');
         document.getElementById('m-dialog-info').remove();
       }
     };
     imgConteint.crossOrigin='anonymus';
     imgConteint.src = image;
   }
 
   onWindowResize(){
 
     this.camera.aspect = this.canvasDestW / this.canvasDestH;
     this.camera.updateProjectionMatrix();
 
     this.renderer.setSize( this.canvasDestW, this.canvasDestH );
 
     //this.controls.handleResize();
     //this.render();
   }
 
   onMouseMove( event ) {
 
     let contDiv = document.getElementsByClassName('ol-viewport')[0];
     let contTop = contDiv.offsetTop;
     let contLeft = contDiv.offsetLeft;
     while(contDiv.parentElement){
       contDiv = contDiv.parentElement;
       contTop += contDiv.offsetTop;
       contLeft += contDiv.offsetLeft;
     }
     this.helper.visible = false;
 
     if ( this.optionsSet.cursor3d ) {
       this.scene.add(this.helper);
       const mouseX = ( (event.clientX - contLeft) / this.canvasDestW ) * 2 - 1;
       const mouseY = -( (event.clientY - contTop) / this.canvasDestH ) * 2 + 1;
 
       const vector = new THREE.Vector3( mouseX, mouseY, this.camera.near );
 
       // Convert the [-1, 1] screen coordinate into a world coordinate on the near plane
       const projector = new THREE.Projector();
       projector.unprojectVector( vector, this.camera );
 
       const raycaster = new THREE.Raycaster( this.camera.position, vector.sub( this.camera.position ).normalize() );
 
       /*raycaster.ray.direction.x = 0;
       raycaster.ray.direction.y = -1;
       raycaster.ray.direction.z = 0;*/
 
       // See if the ray from the camera into the world hits one of our meshes
       const intersects = raycaster.intersectObject( this.mesh );
 
       // Toggle rotation bool for meshes that we clicked
       if (intersects.length > 0) {
         this.helper.visible = true;
         document.getElementsByClassName('ol-viewport')[0].style.cursor = 'none';
 
         this.helper.position.set( 0, 0, 0 );
         //this.helper.position.set( this.camera.position.x, this.camera.position.y, this.camera.position.z );
         this.helper.lookAt( intersects[ 0 ].face.normal );
 
         this.helper.position.copy( intersects[ 0 ].point );
         this.redrawInfo(intersects[0].point.x, intersects[0].point.y, intersects[0].point.z);
       }else{
         document.getElementsByClassName('ol-viewport')[0].style.cursor = 'auto';
       }
     }
   }
 
   redrawInfo(X,Y,Z){
 
     const info  = '<b>Project: ' + this.datumImg.proy + ' - Datum:' + this.datumImg.datum + '</b><br><b>X/lon:</b> ' + Math.round(X/this.geo2UTM*10000)/10000 + '<br><b>Y/lat:</b> ' + Math.round(Y/this.geo2UTM*10000)/10000  + '<br><b>Z:</b> ' + Math.round(Z*100)/100;
     this.addInfo(info);
   }
 
   addInfo(info){
     document.getElementById('infoGeo3d').innerHTML = info;
   }
 
   obtainZmeshRtr(widthDTM,heightDTM,bboxDTM0,bboxDTM1,bboxDTM2,bboxDTM3,srsDTM){
 
     const imgDTMconteint = new Image();
     imgDTMconteint.addEventListener('load', () => {
       let j = 0;
 
       let canvasDTMrtr = document.getElementById('canvasDTMrtr');
       if(!canvasDTMrtr){
         canvasDTMrtr = document.createElement('CANVAS');
         canvasDTMrtr.id = 'canvasDTMrtr';
       }
 
       canvasDTMrtr.setAttribute('width',widthDTM);
       canvasDTMrtr.setAttribute('height',heightDTM);
 
       //document.body.appendChild(canvasDTMrtr);
       //this.addObjToResize(canvas.id);
       let ctxDTMrtr = canvasDTMrtr.getContext('2d');
       ctxDTMrtr.drawImage(imgDTMconteint, 0, 0, widthDTM, heightDTM);
 
       const imageData = ctxDTMrtr.getImageData(0,0,widthDTM,heightDTM);
       const pixels = imageData.data;
       for (var i = 0, il = pixels.length; i < il; i+= 4) {
         this.arrayZ[j] = (pixels[i+0]*1024 + pixels[i+1]*32 + pixels[i+2]/2)*2/8;
         if(this.arrayZ[j] > 4000){
           this.arrayZ[j] = 0;
         }
         j++;
       }
       this.assignZmesh();
 
     });
     imgDTMconteint.crossOrigin='anonymus';
 
 
     //imgDTMconteint.src = 'http://sintetico.sigrid3d.com/SgdWms/SgdWms.dll/WMS?&VERSION=1.1.1&REQUEST=GetMap&LAYERS=DTM_espana_5m_etrs89&FORMAT=image/bmp&SRS='+srsDTM+'&BBOX='+bboxDTM0+','+bboxDTM1+','+bboxDTM2+','+bboxDTM3+'&EXCEPTIONS=application/vnd.ogc.se_inimage&WIDTH='+widthDTM+'&HEIGHT='+heightDTM;
     imgDTMconteint.src = 'https://www.ign.es/3d-stereo/sintetico/SgdWms.dll/WMS?&VERSION=1.1.1&REQUEST=GetMap&LAYERS=DTM_espana_5m_etrs89&FORMAT=image/bmp&SRS='+srsDTM+'&BBOX='+bboxDTM0+','+bboxDTM1+','+bboxDTM2+','+bboxDTM3+'&EXCEPTIONS=application/vnd.ogc.se_inimage&WIDTH='+widthDTM+'&HEIGHT='+heightDTM;
 
     /*if(this.datumImg.proy == 'Lon-Lat'){
       imgDTMconteint.src = 'http://pruebas1.sigrid.es/SgdWms/SgdWms.dll/WMS?&VERSION=1.1.1&REQUEST=GetMap&LAYERS=spain_lan_10mGEO&FORMAT=image/bmp&SRS='+srsDTM+'&BBOX='+bboxDTM0+','+bboxDTM1+','+bboxDTM2+','+bboxDTM3+'&EXCEPTIONS=application/vnd.ogc.se_inimage&WIDTH='+widthDTM+'&HEIGHT='+heightDTM;
     }else{
       imgDTMconteint.src = 'http://pruebas1.sigrid.es/SgdWms/SgdWms.dll/WMS?&VERSION=1.1.1&REQUEST=GetMap&LAYERS=spain_lan_10m&FORMAT=image/bmp&SRS='+srsDTM+'&BBOX='+bboxDTM0+','+bboxDTM1+','+bboxDTM2+','+bboxDTM3+'&EXCEPTIONS=application/vnd.ogc.se_inimage&WIDTH='+widthDTM+'&HEIGHT='+heightDTM;
     }*/
     //imgDTMconteint.src = 'proxy.php?url='+encodeURIComponent(src);
   }
 
   obtainZmeshAsc(widthDTM,heightDTM,bboxDTM0,bboxDTM1,bboxDTM2,bboxDTM3,srsDTM){
 
     const requestDTMwcs = new XMLHttpRequest();
     requestDTMwcs.open('GET', 'proxy.php?fn='+encodeURIComponent('https://www.ign.es/wcs/mdt?SERVICE=WCS&REQUEST=GetCoverage&VERSION=1.0.0&CRS='+srsDTM+'&BBOX='+bboxDTM0+','+bboxDTM1+','+bboxDTM2+','+bboxDTM3+'&COVERAGE=mdt:Elevacion25830_200&WIDTH='+widthDTM+'&HEIGHT='+heightDTM+'&FORMAT=arcgrid'));
     requestDTMwcs.onload = function() {
       let txtDTMwcs = requestDTMwcs.responseText;
       if(txtDTMwcs.indexOf('-9999') != -1){
         let zConteint = txtDTMwcs.slice(txtDTMwcs.indexOf('-9999')+5);
 
         let sinSalto = zConteint.replace(/\n/g, ' ');
         let sinInicio = sinSalto.slice(1);
         let sinFin = sinInicio.slice(0,sinInicio.length-1);
         let arrayZ = sinFin.split(' ');
         for(let i=0 ; i<arrayZ.length ; i++){
           this.arrayZ[i] = eval(arrayZ[i]);
           if(arrayZ[i] <= -1000){
             this.arrayZ[i] = 0;
           }
         }
         this.assignZmesh();
       }else{
         if(document.getElementsByClassName('m-dialog info').length > 0 ) {//asincrono...
           alert('WCS no load, trying DTM sigrid');
           this.obtainZmeshRtr(widthDTM,heightDTM,bboxDTM0,bboxDTM1,bboxDTM2,bboxDTM3,srsDTM);
         }
       }
     }
 
     requestDTMwcs.send();
   }
 
   assignZmesh(){
 
     const arrayZ = this.arrayZ;
     let zMin = arrayZ[0];
     let zMax = arrayZ[0];
 
     for(let i=0 ; i<arrayZ.length ; i++){
       if(arrayZ[i] < zMin){zMin = arrayZ[i];}
       if(arrayZ[i] > zMax){zMax = arrayZ[i];}
     }
 
     const zGreedH = this.reducMeshH+1;
     const zGreedW = this.reducMeshW+1;
     const posZ = Math.round(zGreedH/2)*zGreedW+Math.round(zGreedW/2);//F/2*C+C/2
 
     this.zMed = arrayZ[posZ];
     this.zMax = zMax;
     this.zMin = zMin;
 
     if(arrayZ.length == this.mesh.geometry.vertices.length)
       for(var i=0 ; i<arrayZ.length ; i++){
         //zTerr0 = arrayZ[i];
         //zPix[i] = this.GetGeo2pix(zTerr0);
         this.mesh.geometry.vertices[i].z = arrayZ[i];
         this.mesh.geometry.verticesNeedUpdate = true;
       }
 
     if(this.newMeshMap == 1){//update params and not update camera to init ==> if(!makeScene)
       this.makeScene();
     }else{
       this.renderScene();
     }
     if(document.getElementsByClassName('m-dialog info') [0]!== undefined){
       let canvas = document.getElementById('canvasDest');
       let imgSrc = canvas.toDataURL();
       const imageLayer = new ol.layer.Image({
         name: 'threemapealayer',
         source: new ol.source.ImageStatic({
           imageExtent: this.map.getMapImpl().getView().calculateExtent(this.map.getImpl().getMapImpl().getView().getSizeFromViewport_()),
           imageLoadFunction: function (image) {
             image.getImage().src = imgSrc;
           }
         })
       });
       this.map.getMapImpl().addLayer(imageLayer);
       document.getElementsByClassName('m-dialog info')[0].remove();
     }
     this.newMeshMap = 0;
   }
 
 
 }
 